import { render, staticRenderFns } from "./CreateSpace.vue?vue&type=template&id=30db0e11&scoped=true&"
import script from "./CreateSpace.vue?vue&type=script&lang=js&"
export * from "./CreateSpace.vue?vue&type=script&lang=js&"
import style0 from "./CreateSpace.vue?vue&type=style&index=0&id=30db0e11&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30db0e11",
  null
  
)

export default component.exports